export default __webpack_public_path__ + "static/media/gos.39e4e4bf.mp3";